/* global _ angular swal moment*/

import './style.less';
import { orderBy } from 'lodash';

export default function($log, $state, $q, Swal, ApiClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  vm.approveCert = cert => {
    const tempCert = Object.assign({}, cert);
    tempCert.approved = !cert.approved;
    vm[cert.cert_id + cert.profile_uid] = true;
    return ApiClass.usersIdTypeTypeIdPatch(
      { id: cert.profile_uid, type: 'certificates', type_id: cert.cert_id, manage: false },
      { approved: tempCert.approved },
      {}
    )
      .then(() => {
        vm[cert.cert_id + cert.profile_uid] = false;
        cert.approved = tempCert.approved;
      })
      .catch(error => {
        vm[cert.cert_id + cert.profile_uid] = false;
        $log.error(error);
        throw error;
      });
  };

  vm.deleteCert = cert => {
    Swal.delete()
      .then(() => {
        return ApiClass.usersIdTypeTypeIdDelete(
          { id: cert.profile_uid, type: 'certificates', type_id: cert.cert_id, manage: false },
          {},
          {}
        );
      })
      .then(() => $state.reload())
      .catch(error => {
        if (error === 'cancel' || error === 'overlay') return;
        $log.error(error);
        throw error;
      });
  };

  function activate() {
    ApiClass.scan(
      ApiClass.usersCertificatesGet,
      {},
      {},
      {
        queryParams: {
          manage: true,
          'filter:approved': false,
          'scan:limit': 1000
        }
      }
    )
      .then(data => {
        const { items } = data;
        vm.certificates = orderBy(items, ['cert'], ['asc']);
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/approvals/certificates/index.js